// Generate a random captcha code
export const generateCaptchaCode = (length: number = 6): string => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Validate captcha input against the generated code
export const validateCaptchaInput = (input: string, captchaCode: string): boolean => {
  return input.trim().toLowerCase() === captchaCode.toLowerCase();
};